var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warranty-svgrepo-com",
    transform: "translate(-0.25 -0.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M20.6,2.27a4.08,4.08,0,0,1,6.3,0l2.453,2.978A4.082,4.082,0,0,0,32.9,6.717l3.839-.372A4.094,4.094,0,0,1,41.2,10.824l-.369,3.8a4.106,4.106,0,0,0,1.477,3.569l2.945,2.422a4.108,4.108,0,0,1,0,6.342l-2.945,2.422a4.106,4.106,0,0,0-1.477,3.569l.369,3.8a4.094,4.094,0,0,1-4.462,4.479L32.9,40.845a4.082,4.082,0,0,0-3.545,1.47L26.9,45.292a4.08,4.08,0,0,1-6.3,0l-2.453-2.978a4.082,4.082,0,0,0-3.545-1.47l-3.839.372A4.094,4.094,0,0,1,6.3,36.739l.369-3.8a4.106,4.106,0,0,0-1.477-3.569L2.246,26.952a4.108,4.108,0,0,1,0-6.342l2.945-2.422A4.106,4.106,0,0,0,6.669,14.62l-.369-3.8a4.094,4.094,0,0,1,4.462-4.479l3.839.372a4.082,4.082,0,0,0,3.545-1.47Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#76a94b",
    strokeWidth: 1,
    strokeDasharray: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M8.125,16.155l4.793,4.774A2.1,2.1,0,0,0,16.07,20.7l8.3-11.022",
    transform: "translate(7.503 9.214)",
    fill: "none",
    stroke: "#76a94b",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.c3152dc1cfbcff652525ff30e82d40a1.svg";
export { ForwardRef as ReactComponent };